/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import { RangeControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import BlockLayouts from '../../../components/block-layouts';

import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

import infoBoxBlockInfo from '../../info-box/constants';
const { hookPrefix: infoBoxHookPrefix, layouts } = infoBoxBlockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columnSize, hideButtons } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'service',
						initialOpen: true,
						label: () => {
							return __( 'Service' );
						},
						cb: () => {
							return <>
								<RangeControl value={ columnSize } label={ __( 'Columns' ) } min={ 1 } max={ applyFilters( `gutenify--${ hookPrefix }--max-columns`, 4 ) } step={ 1 } onChange={ ( value ) => {
									setAttributes( { columnSize: value } );
								} } />
								<ToggleControl label={ __( 'Hide Buttons' ) } onChange={ () => {
									setAttributes( {
										hideButtons: ! hideButtons,
									} );
								} } checked={ hideButtons } help={
									hideButtons ? __( 'All buttons are hidden' ) : __( 'All buttons are shown.' )
								} />
							</>;
						},
					},
					{
						name: 'info-box',
						initialOpen: true,
						label: () => {
							return __( 'Info Box' );
						},
						cb: () => {
							return <>
								<BlockLayouts layouts={ layouts } value={ layout } blockName={ infoBoxHookPrefix } onChange={ ( val ) => {
									const data = {
										layout: val.name,
										iconAlign: val.iconAlign,
										titleAlign: val.titleAlign,
									};
									setAttributes( data );
									updateInnerBlocks( val );
								} } />
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
